<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-header border-0 bg-white rounded-top py-3">
      <button
        type="button"
        class="btn-close ms-auto"
        @click="closeModal"
      />
    </div>

    <div class="modal-body bg-white px-4 pb-4 pt-0">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto">
          <img
            :src="`${aws}/unicorn-feather.png`"
            class="mx-auto mb-3"
          >
        </div>
        <h5 class="text-center mb-3">
          Informations complémentaires
        </h5>
        <p class="text-center text-md-start mb-4">
          Complétez les informations manquantes pour votre activité.
        </p>

        <component
          :is="formComponent"
          v-if="formComponent"
          ref="formRef"
          :contract="contract"
          :activity-name="activityName"
          @validation="isValid = $event"
        />

        <div class="d-flex flex-column mt-4">
          <v-loader
            :next="saveInformation"
            :force-loading="isLoading"
            :disabled="!isValid"
            class="mb-2"
          >
            Valider mes informations
          </v-loader>
          <button
            type="button"
            class="btn btn-blue-400 text-white"
            @click="closeModal"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';
import { ui } from '@/mixins';

import Accountant from '@/components/customisation/forms/Accountant.vue';
import CAC from '@/components/customisation/forms/CAC.vue';
import Orias from '@/components/customisation/forms/Orias.vue';
import Surveyor from '@/components/customisation/forms/Surveyor.vue';
import ProfessionalCard from '@/components/customisation/forms/ProfessionalCard.vue';

export default {
  name: 'ComplementaryInformationModal',
  components: {
    'v-accountant': Accountant,
    'v-cac': CAC,
    'v-orias': Orias,
    'v-surveyor': Surveyor,
    'v-professional-card': ProfessionalCard,
  },
  mixins: [ui],
  data() {
    return {
      isLoading: false,
      isValid: false,
    };
  },
  computed: {
    contract() {
      return this.$store.getters['contract/get'];
    },
    subscriptionId() {
      return this.$route.params.id;
    },
    mainActivityId() {
      return get(this.contract, 'risk.mainActivity.id', null);
    },
    activityName() {
      return get(this.contract, 'risk.mainActivity.name', 'Activité');
    },
    formComponent() {
      const activityId = this.mainActivityId;

      // Expert comptable ID: 10
      if (activityId === 10) {
        return 'v-accountant';
      }
      // CAC: Commissaire aux comptes  ID: 3
      if (activityId === 3) {
        return 'v-cac';
      }
      // Géomètre expert ID: 7
      if (activityId === 7) {
        return 'v-surveyor';
      }
      // agent immobilier - ID: 13
      // administrateur de biens - ID: 4
      if (activityId === 13 || activityId === 4) {
        return 'v-professional-card';
      }

      // Activities requiring ORIAS number
      // Courtier en Assurance: 16, 18
      // Conseiller en investissement financier: 12
      // IOBSP: 15, 17
      // Mandataire d'intermédiaire d'assurance, Mandataire d'IOBSP: 1, 2
      // IFP: 719
      // Démarcheur bancaire ou financier: 8
      const oriasActivityIds = [1, 2, 8, 12, 15, 16, 17, 18, 719];
      if (oriasActivityIds.includes(activityId)) {
        return 'v-orias';
      }

      return null;
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    closeModal() {
      this.ui_showModal(false);
    },
    async saveInformation() {
      this.isLoading = true;
      try {
        const form = this.$refs.formRef;
        let riskPatch = {};
        if (form && typeof form.submit === 'function') {
          riskPatch = await form.submit();
        }

        await this.$store.dispatch('contract/updatePolicyRisk', riskPatch);
        await this.$store.dispatch('contract/getContractDetail', {
          id: this.subscriptionId,
          entity: this.$route.query.entity || null,
        });

        this.ui_showToast({
          show: true,
          message: 'Informations mises à jour avec succès !',
        });

        this.closeModal();
      } catch (err) {
        console.error('[ComplementaryInformationModal] Error saving information:', err);

        this.ui_showToast({
          show: true,
          message: 'Erreur lors de la mise à jour des informations',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
</style>
